const maxLengthHandlers = new WeakMap();
export default function (Vue) {
    Vue.directive(`blur-loading`, {
        // @ts-ignore
        bind(element, binding) {
            element.style.transition = `all 0.3s`;
        },
        // @ts-ignore
        update(element, binding) {
            if (binding.value) {
                element.style.filter = `blur(2px)`;
                element.style.opacity = `0.6`;
            }
            else {
                element.style.filter = `blur(0px)`;
                element.style.opacity = `1`;
            }
        },
        inserted(element) {
            element.style.filter = `blur(2px)`;
            element.style.opacity = `0`;
            setTimeout(() => {
                element.style.filter = `blur(0px)`;
                element.style.opacity = `1`;
            }, 0);
        },
    });
    Vue.directive(`focus`, {
        // @ts-ignore
        inserted(el, binding) {
            if (binding.value) {
                if (el instanceof HTMLInputElement) {
                    el.focus();
                }
                else {
                    const innerInput = el.querySelector(`input`);
                    if (innerInput) {
                        innerInput.focus();
                    }
                }
            }
        },
    });
    Vue.directive(`on-esc-keydown`, {
        // @ts-ignore
        inserted(element, binding) {
            if (binding.value) {
                const { callback } = binding.value;
                // @ts-ignore
                const keyboardListeners = event => {
                    if (event.keyCode === 27) {
                        callback();
                    }
                };
                window.addEventListener(`keydown`, keyboardListeners);
                element.$destroy = () => {
                    window.removeEventListener(`keydown`, keyboardListeners);
                };
            }
        },
        unbind(element) {
            if (element.$destroy) {
                element.$destroy();
            }
        },
    });
    /* eslint-disable-next-line */
    const update = (el, binding, vnode, oldVnode) => el.style.visibility = (binding.value) ? 'hidden' : '';
    Vue.directive('hide', {
        bind: update,
        update,
    });
    Vue.directive('max-length', {
        bind(el, binding) {
            const maxLength = binding.value;
            if (typeof maxLength !== 'number' || maxLength <= 0) {
                console.warn('v-max-length directive requires a positive number');
                return;
            }
            const handleInput = (event) => {
                const target = event.target;
                if (target.value.length > maxLength) {
                    target.value = target.value.substring(0, maxLength);
                    target.dispatchEvent(new Event('input', { bubbles: true }));
                }
            };
            const handlePaste = (event) => {
                const target = event.target;
                const clipboardData = event.clipboardData?.getData('text') || '';
                const currentValue = target.value;
                const currentLength = currentValue.length;
                if (currentLength + clipboardData.length > maxLength) {
                    event.preventDefault();
                    const allowedLength = maxLength - currentLength;
                    const truncatedValue = clipboardData.substring(0, allowedLength);
                    if (truncatedValue) {
                        target.value = currentValue + truncatedValue;
                        target.dispatchEvent(new Event('input', { bubbles: true }));
                    }
                }
            };
            const handleKeyDown = (event) => {
                const target = event.target;
                const currentLength = target.value.length;
                const allowedKeys = [
                    'Tab', 'Backspace', 'Delete', 'ArrowLeft', 'ArrowRight',
                    'ArrowUp', 'ArrowDown', 'Home', 'End',
                ];
                const isCtrlCmd = event.ctrlKey || event.metaKey;
                const isAllowedKey = allowedKeys.includes(event.key);
                const isSelectAll = isCtrlCmd && event.key === 'a';
                const isCopy = isCtrlCmd && event.key === 'c';
                const isPaste = isCtrlCmd && event.key === 'v';
                const isCut = isCtrlCmd && event.key === 'x';
                if (currentLength >= maxLength && !isAllowedKey && !isSelectAll && !isCopy && !isPaste && !isCut) {
                    event.preventDefault();
                }
            };
            el.addEventListener('input', handleInput);
            el.addEventListener('paste', handlePaste);
            el.addEventListener('keydown', handleKeyDown);
            maxLengthHandlers.set(el, {
                input: handleInput,
                paste: handlePaste,
                keydown: handleKeyDown,
            });
        },
        update(el, binding) {
            const newMaxLength = binding.value;
            const target = el;
            if (typeof newMaxLength === 'number' && newMaxLength > 0) {
                if (target.value && target.value.length > newMaxLength) {
                    target.value = target.value.substring(0, newMaxLength);
                    target.dispatchEvent(new Event('input', { bubbles: true }));
                }
            }
        },
        unbind(el) {
            const handlers = maxLengthHandlers.get(el);
            if (handlers) {
                el.removeEventListener('input', handlers.input);
                el.removeEventListener('paste', handlers.paste);
                el.removeEventListener('keydown', handlers.keydown);
                maxLengthHandlers.delete(el);
            }
        },
    });
}
